type WhitelistRow = {
  dateAdded?: string | Date;
  createdAt?: { seconds?: number; _seconds?: number } | string | Date;
};
  
  export const getTimestamp = (row: WhitelistRow): number => {
    const createdAt = row.createdAt;
    if (createdAt && typeof createdAt === "object") {
      const sec =
        "seconds" in createdAt
          ? createdAt.seconds
          : "_seconds" in createdAt
            ? createdAt._seconds
            : undefined;
      if (sec != null) return sec * 1000;
    }
    if (createdAt instanceof Date) return createdAt.getTime();
    if (typeof createdAt === "string") return new Date(createdAt).getTime() || 0;

    if (row.dateAdded instanceof Date) return row.dateAdded.getTime();

    const match =
      typeof row.dateAdded === "string"
        ? row.dateAdded.match(
            /^(\d{2})\/(\d{2})\/(\d{4})\s+(\d{2}):(\d{2}):(\d{2})/
          )
        : null;
    if (!match) return 0;
  
    const [, d, m, y, h, min, s] = match;
    return new Date(+y, +m - 1, +d, +h, +min, +s).getTime();
  };